module.exports = {
      id: "arrow-up-usage",
      viewBox: "0 0 18 20",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#arrow-up",
      toString: function () {
        return this.url;
      }
    }